export default "__VITE_ASSET__DNGmMPQ4__"